// extracted by mini-css-extract-plugin
module.exports = {"el":"index-module--el--1g_DN","heading":"index-module--heading--1porm","description":"index-module--description--2lvDZ"};